import { useId } from "react"
import { Field, FieldError, FieldLabel } from "~/components/ui/field"
import { Input } from "~/components/ui/input"
import { organizationSchema, teamOnboardingSchema } from "~/lib/schemas"
import { LogoUploadField } from "./LogoUploadField"

export function IdentityFields({
	kind,
	name,
	slug,
	logo,
	disabled,
	nameError,
	slugError
}: {
	kind: "Organization" | "Team"
	name?: string
	slug?: string
	logo?: string | null
	disabled?: boolean
	nameError?: string
	slugError?: string
}) {
	const id = useId()
	const schema =
		kind === "Organization" ? organizationSchema : teamOnboardingSchema
	return (
		<div className="flex flex-col gap-5">
			<div className="grid gap-5 sm:grid-cols-2">
				<Field data-invalid={!!nameError}>
					<FieldLabel htmlFor={id + "-name"}>{kind} Name</FieldLabel>
					<Input
						id={id + "-name"}
						name="name"
						maxLength={schema.shape.name.maxLength ?? undefined}
						placeholder="Buape Studios"
						disabled={disabled}
						defaultValue={name}
						aria-invalid={!!nameError}
					/>
					{nameError && <FieldError>{nameError}</FieldError>}
				</Field>
				<Field data-invalid={!!slugError}>
					<FieldLabel htmlFor={id + "-slug"}>{kind} Slug</FieldLabel>
					<Input
						id={id + "-slug"}
						name="slug"
						minLength={schema.shape.slug.minLength ?? undefined}
						maxLength={schema.shape.slug.maxLength ?? undefined}
						placeholder="buape-studios"
						disabled={disabled}
						defaultValue={slug}
						aria-invalid={!!slugError}
					/>
					{slugError && <FieldError>{slugError}</FieldError>}
				</Field>
			</div>
			<LogoUploadField
				id={id + "-logo"}
				label={kind + " Logo"}
				currentLogo={logo}
				fallback={name ?? kind}
				disabled={disabled}
			/>
		</div>
	)
}
